import Api from "../Api";

class UserApi {

    getUserInfo = (params?, queryParams?) => {
        return Api.get('/customer-detail', params, queryParams);
    }

    getCaptcha = (uid?, params?, queryParams?) => {
        return Api.get(`/captcha/${uid}`, params, queryParams);
    }

    login = (userName?, password?) => {
        return Api.post("/login", {username: userName, password: password}, {}, {});
    }

    forgotPassword = (userName, email, inputCaptcha, uuid) => {
        return Api.post('/forgot-password', {username: userName, email: email, captchaAnswer: inputCaptcha, captchaKey: uuid}, {}, {});
    }

    resetPassword = (oldPassword?, newPassword?, confirmPassword?, params?, queryParams?) => {
        return Api.post("/reset-password", {
            oldPassword: oldPassword,
            password: newPassword,
            confirmPassword: confirmPassword
        }, params, queryParams);
    }

    changePasswordSuccess = (key) => {
        return Api.post(`update-password/${key}`, {}, {}, {})
    }

    logOut = () => {
        return Api.get('/log-out', {}, {})
    }

}

export default new UserApi();
